// CMS plugin, so Vue can get at some CMS details if necessary.

const classList = document.body.classList;
const templatesPath = '/web/BVM/BVM/Templates';

class Plugin {
  constructor() {
    this.isCMS = classList.contains('cms');
    this.isPreview = classList.contains('preview');
    this.virtualPath = classList.contains('cms') || classList.contains('preview') ? templatesPath : '';
  }

  install(Vue) {
    Vue.prototype.$cms = this;
  }
}

export default new Plugin();